import { render, staticRenderFns } from "./MessagingAppAtEdit.vue?vue&type=template&id=3258fa2a&scoped=true&"
import script from "./MessagingAppAtEdit.vue?vue&type=script&lang=js&"
export * from "./MessagingAppAtEdit.vue?vue&type=script&lang=js&"
import style0 from "./MessagingAppAtEdit.vue?vue&type=style&index=0&id=3258fa2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258fa2a",
  null
  
)

export default component.exports